import type { EstadoDeExoneracion } from '@/shared/api/tipos';

export const ESTADOS: Record<
  EstadoDeExoneracion,
  { etiqueta: string; clase: string; punto: string; descuenta: boolean }
> = {
  pendiente: {
    etiqueta: 'Pendiente',
    clase: 'bg-amber-50 text-amber-700 ring-amber-200',
    punto: 'bg-amber-500',

    descuenta: false,
  },
  aprobada: {
    etiqueta: 'Aprobada',
    clase: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
    punto: 'bg-emerald-500',
    descuenta: true,
  },
  rechazada: {
    etiqueta: 'Rechazada',
    clase: 'bg-red-50 text-red-600 ring-red-200',
    punto: 'bg-red-400',
    descuenta: false,
  },
  suspendida: {
    etiqueta: 'Suspendida',
    clase: 'bg-armazon-100 text-armazon-500 ring-armazon-200',
    punto: 'bg-armazon-400',
    descuenta: false,
  },
};
